var map = {
	"./bettercotton.png": 4836,
	"./bettercotton_inv.png": 8556,
	"./bettercotton_reg.png": 8791,
	"./details.png": 9345,
	"./excel.png": 6010,
	"./material.png": 8624,
	"./power-bi.png": 6992,
	"./radixtree.png": 6793,
	"./radixtree_inv.png": 1557,
	"./radixtree_reg.png": 9070,
	"./retraced.png": 4077,
	"./retraced_inv.png": 7489,
	"./retraced_reg.png": 2810,
	"./textilegenesis.png": 9448,
	"./textilegenesis_inv.png": 9176,
	"./textilegenesis_reg.png": 4547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;